import type { ReactNode } from 'react';
import { HoverCardWithText } from '@/common/components/shared/hover-card/HoverCardWithText';
import { StringUtils } from '@/common/utils';

interface Props {
  children: ReactNode;
  className?: string;
  label: ReactNode;
  hoverCardText?: string;
}

export const ReadonlyDetail = ({ label, children, className, hoverCardText }: Props) => (
  <div className={className}>
    <div className="text-gray-7 mb-1">{label}</div>
    <HoverCardWithText hoverCardContent={hoverCardText} disabled={!hoverCardText}>
      {typeof children === 'string' ? (
        <span dangerouslySetInnerHTML={{ __html: StringUtils.toHTMLAnchor(children) }} />
      ) : (
        children
      )}
    </HoverCardWithText>
  </div>
);
